import React from 'react';
import {
  Table
} from 'antd';
import PropTypes from 'prop-types';
import TableWrapper from 'styles/TableWrapper';

const { Column } = Table;

const OrdersTable = props => {
  const { orders } = props;

  return (
    <TableWrapper>
      <Table dataSource={orders} scroll={{ x: true }}>
        <Column title="Date" dataIndex="createdAt" key="createdAt" />
        <Column title="Numéro" dataIndex="id" key="id" />
        <Column
          title="Total HT €"
          key="totalHT"
          render={(record) => (
            record.totalHT.toFixed(2)
          )}
        />
      </Table>
    </TableWrapper>
  );
};

OrdersTable.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    totalHT: PropTypes.number
  }))
};

export default OrdersTable;
